<label class="d-inline-flex align-items-center">{{ showLabel ? (labelText|translate) : '' }}:
  <input
    type="text" [placeholder]="(placeholderText|translate) + '...' "
    class="form-control form-control-sm ms-2"
    #searchInput aria-controls="tickets-table">
</label>
